var ConfigView = Control.extend({
	init: function(p) {
		this.base('div', p);
		this.setAttribute('layout', 'configview')
		this.classList.add('configview');
	},
	text: {
		get: function() {
		},
		set: function(value) {
		}
	}
});